import * as React from 'react';
import Check from '@telia-front/check';
const CompareCheck = (props) => {
    return (React.createElement(Check, { id: `compare-check-${props.id}`, labelText: props.labelText, onChange: props.onChange, value: "compare-check", checked: props.checked, disabled: props.disabled, className: "product-comparison__check" },
        React.createElement("span", { className: "text-bold" }, props.labelText)));
};
export default CompareCheck;
